import { useMe } from '../../api/me.ts';
import { can } from '../../shell/nav.ts';
import { CommentsPanel } from '../comments/index.ts';
import { FreezeBanner, useFreezeParam } from '../freeze/index.ts';

// Slots on the task page for panels built in other lanes:
//   FreezeBannerSlot   → FreezeBanner (T32, wired in wave 4): "after freeze" / frozen view banner.
//   CommentsPanelSlot  → lane B CommentsPanel (T23): plain-text comments on the task (wired).
// Keep the props: both panels need the task id, and the freeze banner the as-of day.

export interface TaskSlotProps {
  readonly taskId: string;
  readonly asOf: string | undefined;
}

/** FreezeBanner (T32), above the task header: live "after freeze" note, or the frozen view's. */
export function FreezeBannerSlot(props: TaskSlotProps): React.JSX.Element | null {
  const me = useMe();
  const { freezeId, setFreeze } = useFreezeParam();
  if (!can(me, 'freeze.read')) return null;
  return (
    <FreezeBanner
      entityType="task"
      entityKey={props.taskId}
      freezeId={freezeId}
      onSelectFreeze={setFreeze}
    />
  );
}

/** Lane B CommentsPanel (T23), between the runbook and the history. */
export function CommentsPanelSlot(props: TaskSlotProps): React.JSX.Element | null {
  return <CommentsPanel taskId={props.taskId} />;
}
